<template>
  <div>
    <v-container fluid ref="table_container" class="pa-0">
      <v-row no-gutters class="flex-nowrap" v-if="columns.length > 0"
        ><v-col>
          <!-- <div> -->
          <v-simple-table fixed-header>
            <template v-slot:default>
              <TableColumnHeaders
                v-if="!hideHeading"
                :dataColumns="columns"
                :preColumns="[]"
                :postColumns="rows.length && rows[0].doc_id && !hideActionColumn ? [''] : []"
                :rows="rows"
                :stateKey="stateKey"
                :presetFilters="columnFilters"
                :useJATheme="true"
                :hideFilter="hideFilter"
                :hideSort="hideSort"
                @sortby="setSort($event)"
                @filterApplied="applyColumnFilters($event)"
              ></TableColumnHeaders>
              <tbody @wheel.stop="pageScroll($event)">
                <tr
                  v-for="(d, di) in pageRows"
                  :key="'d' + d.level + '_' + di"
                  :class="d.cssClassRow"
                  :style="getRowStyle(d)"
                  @click="d.isGroup ? toggleGroup(d) : rowClick($event, d.detail)"
                  @contextmenu="d.isGroup ? undefined : openContextMenu($event, d.detail)"
                >
                  <template v-if="d.isGroup">
                    <td
                      :colspan="columns.length + (rows.length && rows[0].doc_id ? 1 : 0)"
                      class="group-cell first-column last-column"
                      :style="{ paddingLeft: (d.level * 20 + 8) + 'px' }"
                    >
                      <v-icon small class="mr-1">{{ d.expanded ? 'mdi-chevron-down' : 'mdi-chevron-right' }}</v-icon>
                      <strong>{{ d.groupValue }}</strong>
                      <span class="group-count ml-2">({{ d.groupCount }})</span>
                    </td>
                  </template>
                  <template v-else>
                    <td
                      v-for="(c, ci) in columns"
                      :key="'d' + di + 'c' + ci"
                      class="row-cell"
                      :class="
                        d.cssClassColumns[ci] +
                        (di === pageRows.length - 1 ? ' last-row' : '') +
                        (ci === columns.length - 1 && !d.detail.doc_id
                          ? ' last-column'
                          : '') +
                        (c.link ? ' showAsLink' : '')
                      "
                      @click="cellClick($event, c, d.detail)"
                    >
                      <template>
                        <DocStatus
                          v-if="c.column === 'document_status'"
                          :doc_id="d.detail.doc_id"
                          sideAddendum
                        ></DocStatus>
                        <v-chip
                          v-else-if="c.column === 'task_status'"
                          dense
                          small
                          class="status-chip"
                          label
                          :color="d.detail.task_status_colour"
                          >{{ d.detail[c.column] }}</v-chip
                        >
                        <div v-else-if="c.column === 'document_comment_count'">
                          <CommentsCount
                            v-if="d.detail.document_comment_count != 0"
                            :document="d.detail"
                            @openDocument="openDocument"
                          ></CommentsCount>
                        </div>
                        <span v-else>
                          {{ formatValue(c, d.detail[c.column]) }}</span
                        >
                      </template>
                    </td>
                    <td
                      v-if="d.detail.doc_id && !hideActionColumn"
                      class="last-column"
                      :class="di === pageRows.length - 1 ? 'last-row' : ''"
                    >
                      <v-btn
                        small
                        icon
                        @click.stop="openContextMenu($event, d.detail)"
                      >
                        <v-icon>mdi-dots-vertical</v-icon>
                      </v-btn>
                    </td>
                  </template>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          <!-- </div><div --> </v-col
        ><v-col
          v-if="vScroll.dMax > vScroll.pageRows"
          :style="{ height: vScroll.pageHeight + 'px' }"
          style="
            overflow-y: auto;
            overflow-x: hidden;
            margin-top: 50px;
            margin-left: -10px;
            max-width: 20px;
          "
          ref="scrollContainer"
          @scroll="setVScroll_"
        >
          <div
            ref="scrollBar"
            :style="{ height: vScroll.maxHeight, width: '1px' }"
          ></div>
          <!-- </div> -->
        </v-col>
      </v-row>
    </v-container>
    <DocSummary
      :doc_id="documentSummary.doc_id"
      :trigger="documentSummary.trigger"
      @openDocument="openDocument"
      @copyDocument="$emit('copyDocument', $event)"
    ></DocSummary>

    <v-menu
      v-model="contextMenu"
      absolute
      :position-x="posX"
      :position-y="posY"
      offset-y
      :close-on-content-click="false"
      nudge-width="300"
    >
      <v-card>
        <v-list dense>
          <v-list-item @click="openDocumentSummary($event, currentRow)">
            <v-list-item-icon>
              <v-icon>mdi-pencil-box-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Document Summary</v-list-item-title>
          </v-list-item>
          <v-list-item @click="openDocument(currentRow)">
            <v-list-item-icon>
              <v-icon>mdi-book-open</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Full Document</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-card>
    </v-menu>
    <ResponseHandler :serviceResponse="response"></ResponseHandler>
    <!-- <Loading :isVisible="isLoading" /> -->
  </div>
</template>
  
<script>
import { ref, reactive, computed, watch, nextTick, getCurrentInstance } from "vue";
import ResponseHandler from "@/components/ResponseHandler";
import DocStatus from "@/components/common/DocStatus";
import TableColumnHeaders from "@/components/common/TableColumnHeaders";
import DocSummary from "@/components/common/DocViewPopUp";
import CommentsCount from "@/components/comments/CommentsCount.vue";
import utils from "@/common/utils.js";
import dayjs from "dayjs";

const _page = "TableAlt";
export default {
  name: _page,
  components: {
    ResponseHandler,
    DocStatus,
    TableColumnHeaders,
    DocSummary,
    CommentsCount,
  },
  props: {
    columns: { type: Array, default: () => [] },
    rows: { type: Array, default: () => [] },
    maxHeight: { type: Number, required: false, default: 0 },
    hideFilter: Boolean,
    hideSort: Boolean,
    hideActionColumn: Boolean,
    rowClickDocSummary: Boolean,
    hideHeading: Boolean,
    groupColumns: { type: Array, default: () => [] },
    expandGroups: { type: Array, default: () => ["none"] },
  },
  setup(props, { emit }) {
    const { proxy } = getCurrentInstance();
    const store = proxy.$store;

    // Template refs
    const table_container = ref(null);
    const scrollContainer = ref(null);
    const scrollBar = ref(null);

    // State
    const internal_rows = ref([]);
    const visible_rows = ref([]);
    const stateKey = ref(1);
    const columnFilters = ref([]);
    const sortColumn = ref({ name: null, descending: false, isNumber: false });
    const tableHeight = ref("700px");
    const pageRows = ref([]);
    const filterList = ref([]);
    const response = ref(null);
    const contextMenu = ref(false);
    const tableHeightTimeout = ref(null);
    const posX = ref(null);
    const posY = ref(null);
    const currentRow = ref({});
    const selectedDocs = ref([]);

    const vScroll = reactive({
      pageHeight: 0,
      maxHeight: 0,
      doSetup: false,
      dStart: 0,
      dEnd: 0,
      dMax: 0,
      inProgress: false,
      lineHeight: 48,
      pageRows: 0,
    });

    const documentSummary = reactive({
      trigger: null,
      doc_id: null,
    });

    // Computed
    const rowClickAction = computed(() => "opendoc");
    const isLoading = computed(() => store.state.docs.loading);
    const hierarchyTypes = computed(() => store.state.docs.hierarchyTypes);
    const documentTypes = computed(() =>
      store.state.docs.docTypeSummary.filter((x) => x.tmpl_id)
    );

    // Methods
    function onPaneResize() {
      if (tableHeightTimeout.value) {
        clearTimeout(tableHeightTimeout.value);
        tableHeightTimeout.value = null;
      }
      tableHeightTimeout.value = setTimeout(() => setTableHeight(), 50);
    }

    function setTableHeight() {
      if (!table_container.value) return;
      const pos = table_container.value.getBoundingClientRect();
      let availableHeight = window.innerHeight - pos.top;
      if (availableHeight < 250) availableHeight = 250;
      if (props.maxHeight && availableHeight > props.maxHeight)
        availableHeight = props.maxHeight;
      tableHeight.value = `${availableHeight}px`;
      vScroll.pageRows = Math.floor(availableHeight / vScroll.lineHeight);
      vScroll.pageHeight = vScroll.pageRows * vScroll.lineHeight;
      vScroll.dStart = 0;
    }

    function setVScroll_(event) {
      if (event.target.closest(".resizable-component")) return;
      if (vScroll.inProgress) {
        vScroll.inProgress = false;
        return;
      }
      let sl = scrollContainer.value.scrollTop;
      let max = scrollContainer.value.scrollHeight;
      let start = 0;
      if (sl > 0) {
        start = parseInt((vScroll.dMax * sl) / max);
      }
      if (start !== vScroll.dStart) {
        vScroll.dStart = start;
        pageChanged();
      }
    }

    function setVScrollMax(rowCount) {
      vScroll.dMax = rowCount;
      const rowHeight = vScroll.lineHeight;
      vScroll.maxHeight = rowCount * rowHeight + "px";
    }

    function documentChanged(doc) {
      store.dispatch("docs/updateDoc", doc);
      filterMatches();
    }

    function formatValue(column, value) {
      if (["due_date", "completed_date"].some((x) => x === column.value))
        return formatDate(value);
      else return value;
    }

    function formatDate(value) {
      return value ? dayjs(value).format("D MMM YYYY") : "";
    }

    function parseDate(date) {
      if (!date) return null;
      return dayjs(date).format("YYYY-MM-DD");
    }

    function setView() {
      stateKey.value++;
      filterMatches();
    }

    function filterMatches(sameState) {
      if (!sameState) stateKey.value++;
      let sourcedata = props.rows;
      let activeFilters = columnFilters.value
        ? columnFilters.value
            .filter((f) => f.filterSettings.isActive)
            .map((f) => {
              let cf = {
                column: f.value,
                name: f.text,
                values: f.filterSettings.values
                  .filter((v) => v.selected)
                  .map((v) => v.value),
              };
              cf.title = `${cf.name} = [${cf.values.join(", ")}]`;
              return cf;
            })
        : [];
      filterList.value = JSON.parse(JSON.stringify(activeFilters));
      if (activeFilters.length) {
        sourcedata = sourcedata.filter((x) => {
          return activeFilters.every((f) =>
            f.values.some((v) => x[f.column] === v)
          );
        });
      }
      setupInternalRows(sourcedata);
      setVisibleRows();
      pageChanged(0);
    }

    function setupInternalRows(data) {
      let rows = [];

      if (props.groupColumns && props.groupColumns.length > 0) {
        // Pre-sort data if sort column is set
        let sortedData = data;
        if (sortColumn.value.name) {
          const col = sortColumn.value.name;
          const isNum = sortColumn.value.isNumber;
          const dir = sortColumn.value.descending ? -1 : 1;
          sortedData = [...data].sort((a, b) => {
            const aVal = isNum ? (a[col] || 0) : (a[col]?.toLowerCase?.().trim() || "");
            const bVal = isNum ? (b[col] || 0) : (b[col]?.toLowerCase?.().trim() || "");
            return dir * (aVal > bVal ? 1 : aVal < bVal ? -1 : 0);
          });
        }
        buildGroupedRows(sortedData, props.groupColumns, 0, null, rows, true);
      } else {
        let addRows = (sourceRows, level, parentKey) => {
          sourceRows.forEach((r, ri) => {
            const key = `${parentKey ? parentKey + "_" : ""}${r.doc_id}`;
            rows.push({
              level: level,
              detail: r,
              key: key,
              parentKey: parentKey,
              expanded: false,
              selected: false,
              visible: level === 0,
              index: ri,
              visibleChildren: 0,
              cssClassRow: level > 0 ? "sub-row" : "",
              cssClassColumns: props.columns.map((c, ci) =>
                ci === 0
                  ? "first-column"
                  : ci === props.columns.length - 1
                  ? ""
                  : ""
              ),
            });
          });
        };
        addRows(data, 0, null);
      }

      internal_rows.value = rows;
    }

    function shouldExpandGroup(groupIndex, totalGroups) {
      const expand = props.expandGroups;
      if (expand.includes("all")) return true;
      if (expand.includes("none")) return false;
      if (expand.includes("first") && groupIndex === 0) return true;
      if (expand.includes("last") && groupIndex === totalGroups - 1) return true;
      return false;
    }

    function buildGroupedRows(data, groupCols, levelIndex, parentKey, rows, parentIsOpen) {
      const col = groupCols[levelIndex];
      const groups = {};
      const groupOrder = [];
      data.forEach((r) => {
        const val = r[col] ?? "";
        if (!groups[val]) {
          groups[val] = [];
          groupOrder.push(val);
        }
        groups[val].push(r);
      });

      const totalGroups = groupOrder.length;
      groupOrder.forEach((groupValue, groupIndex) => {
        const groupKey = `${parentKey ? parentKey + "_" : ""}g_${levelIndex}_${groupValue}`;
        const isVisible = levelIndex === 0 || parentIsOpen;
        const isExpanded = isVisible && shouldExpandGroup(groupIndex, totalGroups);
        rows.push({
          level: levelIndex,
          isGroup: true,
          groupColumn: col,
          groupValue: groupValue,
          groupCount: groups[groupValue].length,
          detail: {},
          key: groupKey,
          parentKey: parentKey,
          expanded: isExpanded,
          selected: false,
          visible: isVisible,
          index: rows.length,
          hasChildren: true,
          cssClassRow: "group-row group-row-level-" + levelIndex,
          cssClassColumns: [],
        });

        if (levelIndex < groupCols.length - 1) {
          buildGroupedRows(groups[groupValue], groupCols, levelIndex + 1, groupKey, rows, isExpanded);
        } else {
          const detailLevel = levelIndex + 1;
          groups[groupValue].forEach((r, ri) => {
            const key = `${groupKey}_${r.doc_id || ri}`;
            rows.push({
              level: detailLevel,
              isGroup: false,
              detail: r,
              key: key,
              parentKey: groupKey,
              expanded: false,
              selected: false,
              visible: isExpanded,
              index: ri,
              visibleChildren: 0,
              cssClassRow: "sub-row",
              cssClassColumns: props.columns.map((c, ci) =>
                ci === 0 ? "first-column" : ""
              ),
            });
          });
        }
      });
    }

    function setVisibleRows() {
      visible_rows.value = internal_rows.value.filter((x) => x.visible);
      sort();
      setVScrollMax(visible_rows.value.length);
    }

    function getCellStyle(row, colIndex) {
      return colIndex === 0
        ? { paddingLeft: row.level * 40 + "px" }
        : null;
    }

    function sort() {
      // When grouped, sorting is applied during setupInternalRows
      if (props.groupColumns && props.groupColumns.length > 0) return;
      if (sortColumn.value.name) {
        const col = sortColumn.value.name;
        const isNum = sortColumn.value.isNumber;
        const dir = sortColumn.value.descending ? -1 : 1;
        const setSortKey = (rows, parent) => {
          rows.forEach((r) => {
            r.sortKey =
              (parent?.sortKey || "") +
              (isNum
                ? r.detail[col] || 0
                : r.detail[col]?.toLowerCase().trim() || "");
            if (r.expanded) {
              setSortKey(
                visible_rows.value.filter(
                  (x) => x.level === r.level + 1 && x.parentKey === r.key
                ),
                r
              );
            }
          });
        };
        setSortKey(visible_rows.value.filter((x) => x.level === 0));
        visible_rows.value.sort(
          (a, b) =>
            dir * (a.sortKey > b.sortKey ? 1 : a.sortKey < b.sortKey ? -1 : 0)
        );
      }
    }

    function setSort(column) {
      sortColumn.value = column;
      if (props.groupColumns && props.groupColumns.length > 0) {
        // Rebuild groups with new sort order
        filterMatches(true);
      } else {
        setVisibleRows();
        pageChanged(0);
      }
    }

    function applyColumnFilters(filters) {
      columnFilters.value = filters;
      filterMatches(filters.some((f) => f.filterSettings.isActive));
    }

    function removeColumnFilter(f) {
      let lvfilter = columnFilters.value.find((x) => x.value === f.column);
      if (lvfilter) {
        lvfilter.filterSettings.values.forEach((x) => {
          x.selected = false;
          x.applied = false;
        });
        lvfilter.filterSettings.isActive = false;
        filterMatches();
      }
    }

    function selectDocument(row) {
      row.selected = !row.selected;
      if (row.selected) selectedDocs.value.push(row);
      else
        selectedDocs.value = selectedDocs.value.filter(
          (x) => x.detail.doc_id !== row.detail.doc_id
        );
    }

    function pageScroll(data) {
      if (data && vScroll.dMax > vScroll.pageRows) {
        vScroll.dStart +=
          (data.deltaY >= 0 ? 1 : -1) * vScroll.pageRows;
        pageChanged();
      }
    }

    function pageChanged(start) {
      if (start === undefined) start = vScroll.dStart;
      if (start < 0) start = 0;
      if (start >= vScroll.dMax - 1)
        start = vScroll.dMax - vScroll.pageRows;
      vScroll.dStart = start;
      vScroll.dEnd = start + vScroll.pageRows;

      if (scrollContainer.value) {
        let max = scrollContainer.value.scrollHeight;
        scrollContainer.value.scrollTop =
          (max * vScroll.dStart) / vScroll.dMax;
      }

      showCurrentPage();
    }

    function showCurrentPage() {
      pageRows.value = visible_rows.value.slice(
        vScroll.dStart,
        vScroll.dEnd
      );
    }

    function selectRow(event, item) {
      if (rowClickAction.value === "menu") {
        openContextMenu(event, item);
      } else if (item.doc_id && props.rowClickDocSummary) {
        openDocumentSummary(event, item);
      } else {
        emit("rowClick", item);
      }
    }

    function rowClick(event, item) {
      if (item.doc_id && props.rowClickDocSummary) {
        openDocumentSummary(event, item);
      }
    }

    function cellClick(event, column, item) {
      if (column.link === "document_summary") {
        openDocumentSummary(event, item);
      } else if (column.link === "document") {
        openDocument(item);
      }
    }

    function openDocument(item) {
      contextMenu.value = false;
      emit("openDocument", item);
    }

    function openDocumentSummary(event, item) {
      documentSummary.doc_id = item.doc_id;
      documentSummary.trigger = event;
    }

    function openContextMenu(e, item) {
      if (!item.doc_id) return;
      currentRow.value = item;
      e.preventDefault();
      contextMenu.value = false;
      posX.value = e.clientX;
      posY.value = e.clientY;
      nextTick(() => {
        contextMenu.value = true;
      });
    }

    function toggleGroup(row) {
      row.expanded = !row.expanded;
      if (row.expanded) {
        // Show direct children only
        internal_rows.value.forEach((r) => {
          if (r.parentKey === row.key) {
            r.visible = true;
          }
        });
      } else {
        // Hide all descendants and collapse sub-groups
        const hideDescendants = (parentKey) => {
          internal_rows.value.forEach((r) => {
            if (r.parentKey === parentKey) {
              r.visible = false;
              if (r.isGroup && r.expanded) {
                r.expanded = false;
                hideDescendants(r.key);
              }
            }
          });
        };
        hideDescendants(row.key);
      }
      setVisibleRows();
      pageChanged(0);
    }

    function getRowStyle(row) {
      let style = {};
      if (row.style) style = { ...row.style };
      else if (row.detail?.style) style = { ...row.detail.style };
      if (row.expanded) style.cursor = "zoom-out";
      else if (row.hasChildren) style.cursor = "zoom-in";
      return style;
    }

    // Watchers
    watch(() => props.rows, (val) => {
      if (val) setView();
    });

    watch(() => props.columns, (val) => {
      if (val) setView();
    });

    // Created lifecycle (runs during setup)
    columnFilters.value = [];
    nextTick(() => {
      setTableHeight();
      setView();
    });

    return {
      // Template refs
      table_container,
      scrollContainer,
      scrollBar,
      // State
      stateKey,
      columnFilters,
      tableHeight,
      pageRows,
      filterList,
      utils,
      response,
      contextMenu,
      posX,
      posY,
      currentRow,
      vScroll,
      selectedDocs,
      documentSummary,
      // Computed
      rowClickAction,
      isLoading,
      hierarchyTypes,
      documentTypes,
      // Methods
      onPaneResize,
      setTableHeight,
      setVScroll_,
      documentChanged,
      formatValue,
      formatDate,
      parseDate,
      setView,
      filterMatches,
      setSort,
      applyColumnFilters,
      removeColumnFilter,
      selectDocument,
      pageScroll,
      pageChanged,
      showCurrentPage,
      selectRow,
      rowClick,
      cellClick,
      openDocument,
      openDocumentSummary,
      openContextMenu,
      getRowStyle,
      getCellStyle,
      toggleGroup,
    };
  },
};
</script>
  <style lang="scss" scoped>
@import "@/assets/styles/vars";

.filter-col {
  flex-grow: 1;
  flex-shrink: 0;
  max-width: 50%;
  @media (min-width: 960px) {
    max-width: 25%;
  }
  @media (min-width: 1264px) {
    max-width: 14%;
  }
}

.btn-background {
  height: 44px;
  ::v-deep .v-input__slot {
    background: transparent !important;
  }
}

::v-deep .v-select__selections {
  overflow: hidden;
  white-space: nowrap;
  flex-flow: nowrap;
}

th.tf {
  border: 1px solid #d9d9d9;
  background-color: #eeeeee !important;
}
th.th {
  font-weight: bold;
  text-transform: uppercase;
}
th.tf {
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
}
tfoot tr {
  position: sticky;
  bottom: 0;
}
.similarity-label {
  background-color: #eeeeee;
  color: black;
  font-weight: 700;
  font-size: 14px;
  font-family: "DM Sans" !important;
  border-radius: 8px;
  padding: 2px 8px;
  height: 22px;
}
.showAsLink {
  text-decoration: underline;
}
.showAsLink:hover {
  color: green;
  cursor: pointer;
}
.group-row {
  background-color: #FFFFFF;
  cursor: pointer;
  &:hover {
    background-color: #eeeeee !important;
  }
}
.group-cell {
  font-size: 14px;
  white-space: break-spaces;
}
.group-count {
  color: #888;
  font-weight: normal;
  font-size: 12px;
}
</style>
  